var map = {
	"./apoteca.svg": 3780,
	"./cofano.svg": 7333,
	"./cofarle.svg": 419,
	"./cofarme.svg": 5636,
	"./cofas.svg": 2363,
	"./dfg.svg": 4910,
	"./farmathia.svg": 9676,
	"./nafarco.svg": 7891,
	"./novaltia.svg": 1881,
	"./unnefar.svg": 126
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8789;